import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDialogService } from './services/custom-dialog.service';
import { CustomDialogComponent } from './custom-dialog.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomDialogHeaderComponent } from './components/custom-dialog-header/custom-dialog-header.component';
import { CustomDialogFooterComponent } from './components/custom-dialog-footer/custom-dialog-footer.component';
// eslint-disable-next-line max-len
import { CustomDialogButtonsWrapperComponent } from './components/custom-dialog-buttons-wrapper/custom-dialog-buttons-wrapper.component';
import { Subject } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export class Loader implements TranslateLoader {
  private translations = new Subject();
  $translations = this.translations.asObservable();
  getTranslation(lang: string) {
    return this.$translations;
  }
}

export function LoaderFactory() {
  return new Loader();
}

@NgModule({
  declarations: [
    CustomDialogComponent,
    CustomDialogHeaderComponent,
    CustomDialogFooterComponent,
    CustomDialogButtonsWrapperComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: LoaderFactory,
      },
    }),
    MatButtonModule,
    MatDividerModule,
    MatDialogModule,
    MatIconModule,
    FlexLayoutModule,
    ReactiveFormsModule,
  ],
  exports: [TranslateModule],
})
export class CustomDialogModule {}
